import { ReactNode, useState } from 'react';
import styles from './Tabs.module.css';

export interface TabItem {
    id: string;
    label: string;
    content: ReactNode;
}

export interface TabsProps {
    items: TabItem[];
    defaultTab?: string;
}

export const Tabs = ({ items, defaultTab }: TabsProps) => {
    const [activeTab, setActiveTab] = useState(defaultTab || items[0]?.id);

    return (
        <div className={styles.tabs}>
            <div className={styles.tabList} role="tablist">
                {items.map((item) => (
                    <button
                        key={item.id}
                        className={`${styles.tab} ${activeTab === item.id ? styles.active : ''}`}
                        onClick={() => setActiveTab(item.id)}
                        role="tab"
                        aria-selected={activeTab === item.id}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            <div className={styles.tabPanel} role="tabpanel">
                {items.find((item) => item.id === activeTab)?.content}
            </div>
        </div>
    );
};
